export default function changeLang() {
    document.addEventListener('DOMContentLoaded', function() {
        const dropdowns = document.querySelectorAll('.language-dropdown');

        dropdowns.forEach(dropdown => {
            const trigger = dropdown.querySelector('[data-language-trigger]');
            const menu = dropdown.querySelector('[data-language-menu]');
            const arrow = trigger.querySelector('svg');
            const langButtons = dropdown.querySelectorAll('.lang-drop');

            function toggleDropdown() {
                const isMobile = window.innerWidth < 1024; // breakpoint do Tailwind 'lg'

                if (isMobile) {
                    // Lógica Acordeão (Mobile)
                    menu.classList.toggle('hidden');
                    arrow.style.transform = menu.classList.contains('hidden') ? 'rotate(0deg)' : 'rotate(180deg)';
                } else {
                    // Lógica Dropdown (Desktop)
                    const isOpen = menu.classList.contains('opacity-100');
                    if (isOpen) {
                        menu.classList.remove('opacity-100', 'visible');
                        menu.classList.add('opacity-0', 'invisible');
                        arrow.style.transform = 'rotate(0deg)';
                    } else {
                        menu.classList.remove('opacity-0', 'invisible', 'hidden'); // remove hidden caso venha do redimensionamento
                        menu.classList.add('opacity-100', 'visible');
                        arrow.style.transform = 'rotate(180deg)';
                    }
                }
            }

            trigger.addEventListener('click', (e) => {
                e.stopPropagation();
                toggleDropdown();
            });

            // Clique para trocar idioma (AJAX)
            langButtons.forEach(btn => {
                btn.addEventListener('click', function(e) {
                    e.preventDefault();
                    const lang = this.getAttribute('data-lang');
                    const url = document.getElementById("langFunction")?.value;
                    
                    if (!url) return;

                    fetch(url, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
                        },
                        body: JSON.stringify({ lang: lang })
                    })
                    .then(res => res.json())
                    .then(data => {
                        if (data.status) window.location.reload();
                    });
                });
            });
        });

        // Fechar ao clicar fora (apenas desktop)
        document.addEventListener('click', () => {
            if (window.innerWidth >= 1024) {
                dropdowns.forEach(d => {
                    const menu = d.querySelector('[data-language-menu]');
                    menu.classList.add('opacity-0', 'invisible');
                    d.querySelector('svg').style.transform = 'rotate(0deg)';
                });
            }
        });
    });
}
